<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">
  
  <div class="content-section">
    <h2>Assurance Auto Professionnelle</h2>
    <p>
      Vous êtes conducteur d'un véhicule d'entreprise et vous recherchez une assurance Auto Professionnelle, mais vous ne trouvez pas d'assureur ? 
      BROKINS vous trouve l'assurance qu'il vous faut au prix le plus juste. <strong>Contactez-nous !</strong>
    </p>
    <p>
      Par ailleurs, nous avons de nombreux partenaires spécialisés dans les cas difficiles notamment dit les RISQUES AGGRAVÉS : 
      Malus de 3.5, Stupéfiants, Alcoolémie, Annulation de permis, suspension de permis, résilié compagnie, non-paiement, sanction judiciaire...
    </p>
  </div>

  <div class="content-section bg-accent">
    <h2>DES AVANTAGES EXCLUSIFS :</h2>
    <ul class="advantages-list">
      <li>Larges critères de souscription : résilié compagnie, malusé, suspension ou annulation de permis, non-paiement, alcoolémie, stupéfiant</li>
      <li>Garantie sécurisation du permis incluse dès la formule de base.</li>
      <li>Assistance 0 km et véhicule de remplacement en option.</li>
      <li>Souscription et carte verte immédiates.</li>
      <li>Règlement mensuel possible y compris pour les non paiements de prime.</li>
      <li>Réduction automatique de 50% sur la franchise dommage après 12 mois d'assurance sans sinistre responsable.</li>
      <li>Paiement du stage permis.</li>
      <li>Marchandises transportées.</li>
      <li>Remboursement valeur à neuf</li>
      <li>Garantie financière</li>
    </ul>
  </div>

  <div class="content-section">
    <p>
      Nous assurons également les VTC pour le transport de personnes à titre onéreux (UBER, ...).
    </p>
    <p>
      En cas de besoin temporaire d'assurance auto, c'est-à-dire pour assurer le véhicule 1 jour, 1 semaine ou 90 jours d'affilié, 
      il est sans doute conseillé d'assurer le véhicule via une Assurance Auto Temporaire. Le courtier en Assurance BROKINS est partenaire 
      de nombreux assureurs, dont un échantillon en affiche ci-dessous : 
      <strong>GENERALI, APRIL, AXA, FMA, NOVELIA SURAVENIR, NETVOX, ZEPHIR, XENASSUR, PROGEAS</strong>.
    </p>
  </div>
</app-page-layout>
